const TEST_IDS = {
  stats: 'account-stats',
};

export default TEST_IDS;
